module.exports = __webpack_public_path__ + "media/images/icon/icons8-Online Support-b2474a462f2a15594c92aa7282025178.png";